import React, { FC } from 'react';
import { CONSTANTS } from 'config/constants';
import RadioBtnTypeSetting from 'components/property-settings/radio-btn-type-setting/radio-btn-type-setting';
import { useTranslation } from 'react-i18next';
import { PropertyBox, PropertyLabel } from 'components/property-settings/property-shared-styles';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';

type RetainmentProps = {
    handleSettings: (propertyName: string, settingValue: string) => void;
    retainment: string;
    isRequired?: boolean;
    options?: string[];
};

const Retainment: FC<RetainmentProps> = ({ handleSettings, retainment, isRequired, options }: RetainmentProps) => {
    const { t: translate } = useTranslation(['construction-props']);

    return (
        <PropertyBox>
            <Box display="flex">
                <PropertyLabel variant="h5">{translate('RETAINMENT')}</PropertyLabel>
                {isRequired && (
                    <Typography
                        component="span"
                        color="error"
                        fontSize={18}
                        sx={{ marginLeft: '2px', marginTop: '-5px' }}
                    >
                        *
                    </Typography>
                )}
            </Box>
            <RadioBtnTypeSetting
                setting={options ? options : CONSTANTS.RETAINMENT}
                propertyName="retainment"
                settingValue={retainment?.split('RETAINMENT_')[1]}
                handlePropertySelection={handleSettings}
            />
        </PropertyBox>
    );
};

export default Retainment;
